import { Box, Image, Text, Heading } from '@chakra-ui/react';
import React from 'react';

const StreakModalContent = ({ streakLimit }: { streakLimit: number }) => {
	return (
		<Box position={'relative'} pb="30px" bgColor={'#FFFAFB'} borderRadius={'24px'}>
			<Image w="100%" borderRadius={'16px'} src="/images/streak-modal-bg.svg" />
			<Heading color="#03081A" mt="24px" left="50%" transform={'translate(-50%, -50%)'} top="16px" position={'absolute'} as="h3">
				Congratulations!
			</Heading>
			<Image mt="6px" w="133px" mx="auto" src="/images/streaks-main.svg" />

			<Box mt="16px" px="16px" textAlign={'center'}>
				<Text color="#3B3435" textStyle={'body1'}>
					On completeting
				</Text>
				<Heading lineHeight={'32px'} fontSize={'24px'} fontWeight={600} color="#4358F6" mt="5px">
					7 days streak
				</Heading>
				<Text mt="5px" color="#3B3435" textStyle={'body1'}>
					You are amongst the top students who have been practicing daily.
				</Text>
			</Box>
		</Box>
	);
};

export default StreakModalContent;
